import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Form, Field } from 'react-final-form';
import { Unstable_Grid2 as Grid } from '@mui/material';
import SelectFieldAdapter from 'components/shared/field-adapters/SelectFieldAdapter';
import TypeaheadFieldAdapter from 'components/shared/field-adapters/TypeaheadFieldAdapter';
import FilterButtons from 'components/shared/buttons/FilterButtons';
import { currencyOptions, getTrashedOptions } from 'common/constants/options';
import requestStatus from 'common/constants/status';
import StyledFiltersContainer from 'common/theme/filters/StyledFiltersContainer';
import StyledFiltersForm from 'common/theme/filters/StyledFiltersForm';
import { handleTrainerIdChange } from 'common/utils/user';
import useForms from 'hooks/useForms';
import trainerPaymentSlice from 'store/modules/trainerPayment';

function TrainerPaymentFilters() {
  const dispatch = useDispatch();
  const { t } = useTranslation(['labels']);
  const { clearTrainerSearchResults } = useForms();

  const initialValues = useSelector((state) => state.trainerPayment.filters);
  const searchStatus = useSelector((state) => state.trainer.status.search);
  const status = useSelector((state) => state.trainerPayment.status.general);
  const trainerOptions = useSelector((state) => state.trainer.data.search);

  const onFilter = useCallback(
    (values) => {
      dispatch(trainerPaymentSlice.actions.updateFilters(values));
    },
    [dispatch]
  );

  const onTrainerIdChange = handleTrainerIdChange(dispatch);

  const resetForm = useCallback(() => {
    dispatch(trainerPaymentSlice.actions.resetFilters());
  }, [dispatch]);

  return (
    <StyledFiltersContainer>
      <Form
        initialValues={initialValues}
        onSubmit={onFilter}
        render={({ handleSubmit, pristine }) => (
          <StyledFiltersForm onSubmit={handleSubmit}>
            <Grid container spacing={{ xs: 2, lg: 4 }}>
              <Grid xs={12}>
                <Field
                  id="user_id"
                  name="user_id"
                  component={TypeaheadFieldAdapter}
                  fullWidth
                  loading={searchStatus === requestStatus.loading}
                  isMultiple
                  onClose={clearTrainerSearchResults}
                  onInputChange={onTrainerIdChange}
                  options={trainerOptions}
                  renderInputProps={{
                    label: t('trainer', { count: 2, ns: 'labels' })
                  }}
                />
              </Grid>
              <Grid xs={12} sm={6}>
                <Field
                  id="currency"
                  name="currency"
                  component={SelectFieldAdapter}
                  options={currencyOptions}
                  label={t('currency', { ns: 'labels' })}
                  fullWidth
                />
              </Grid>
              <Grid xs={12} sm={6}>
                <Field
                  id="soft_delete"
                  name="soft_delete"
                  component={SelectFieldAdapter}
                  options={getTrashedOptions(t)}
                  label={t('deleted', { ns: 'labels' })}
                  fullWidth
                />
              </Grid>
            </Grid>
            <FilterButtons pristine={pristine} resetForm={resetForm} status={status} />
          </StyledFiltersForm>
        )}
      />
    </StyledFiltersContainer>
  );
}

export default TrainerPaymentFilters;
